const customStyles = {           
    option: (base, state) => ({
        ...base,      
        color: "#006267",
        padding: ".5rem 3rem .5rem .5rem",
        cursor: "pointer",
    }),       
    singleValue: (provided, state) => {
        const opacity = state.isDisabled ? 0.5 : 1;
        const transition = "opacity 300ms";

        return { ...provided, opacity, transition };
    },
}

export default customStyles;